import { taggedTemplateLiteral as _taggedTemplateLiteral } from '../../_virtual/_rollupPluginBabelHelpers.js';
import React__default from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import Theme from '../../Theme/index.js';

var _templateObject, _templateObject2, _templateObject3, _templateObject4;
var _Theme$colors = Theme.colors,
  primaryOpaque = _Theme$colors.primaryOpaque,
  primary = _Theme$colors.primary,
  primaryShadow = _Theme$colors.primaryShadow,
  primaryOpacity = _Theme$colors.primaryOpacity;
var _Theme$fonts = Theme.fonts,
  PlayfairDisplay = _Theme$fonts.PlayfairDisplay,
  Montserrat = _Theme$fonts.Montserrat;
var TileWrapper = styled.div(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  display: flex;\n  flex-basis: 32%;\n  flex-direction: column;\n  justify-content: flex-start;\n  height: 353px;\n  margin-bottom: 25px;\n  background: url(", ");\n  background-position: center;\n  background-size: cover;\n  box-shadow: 0 5px 10px 0 ", ";\n  transition: transform 0.2s ease-in-out;\n\n  @media (min-width: 768px) and (max-width: 1199px) {\n    flex-basis: 49%;\n  }\n\n  @media (max-width: 767px) {\n    flex-basis: 100%;\n  }\n"])), function (props) {
  return props.img;
}, primaryShadow);
var TextFrame = styled.a(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n  display: flex;\n  flex-direction: column;\n  justify-content: flex-end;\n  width: 100%;\n  height: 100%;\n  padding: 30px;\n  background: linear-gradient(\n    0deg,\n    ", ",\n    ", " 12%,\n    ", " 20%,\n    ", " 45%,\n    ", "\n  );\n  &:hover {\n    text-decoration: none;\n  }\n"])), primary, primary, primaryOpacity, primaryOpaque, primaryOpaque);
var Label = styled.p(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n  font-family: ", ";\n  font-size: 10px;\n  font-weight: 500;\n  color: #ffffff;\n  margin: 0;\n  text-transform: uppercase;\n"])), Montserrat);
var Headline = styled.p(_templateObject4 || (_templateObject4 = _taggedTemplateLiteral(["\n  font-family: ", ";\n  font-size: 24px;\n  font-weight: bold;\n  line-height: 1.25;\n  letter-spacing: -0.3px;\n  color: white;\n  margin: 0;\n"])), PlayfairDisplay);
var TileComponent = function TileComponent(_ref) {
  var title = _ref.title,
    link = _ref.link,
    image = _ref.image,
    label = _ref.label;
  return /*#__PURE__*/React__default.createElement(TileWrapper, {
    img: image
  }, /*#__PURE__*/React__default.createElement(TextFrame, {
    href: link
  }, label ? /*#__PURE__*/React__default.createElement(Label, null, label) : null, /*#__PURE__*/React__default.createElement(Headline, null, title)));
};
TileComponent.displayName = "TileComponent";
TileComponent.propTypes = {
  title: PropTypes.string,
  link: PropTypes.string,
  image: PropTypes.string,
  label: PropTypes.string
};

export { Headline, Label, TextFrame, TileWrapper, TileComponent as default };
